export function blankSherpaReferral() {
return [   // Release 2025-12-28 08:45:25
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.96,
   left: 146.64,
   width: 172.56,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.96,
   left: 376.32,
   width: 205.702,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 173.2,
   left: 155.52,
   width: 425.76,
   height: 11.149
}
,
{
   page: 0,
   name: "Address City", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 190.96,
   left: 114.24,
   width: 207.404,
   height: 10.495
}
,
{
   page: 0,
   name: "Address Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 191.44,
   left: 432.24,
   width: 36.72,
   height: 11.149
}
,
{
   page: 0,
   name: "Address Country", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 191.0,
   left: 507.36,
   width: 73.92,
   height: 11.149
}
,
{
   page: 0,
   name: "Email Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 209.2,
   left: 154.08,
   width: 427.811,
   height: 11.149
}
,
{
   page: 0,
   name: "Address State", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 190.494,
   left: 368.072,
   width: 29.280,
   height: 12.459
}
,
{
   page: 0,
   name: "Agent Cell Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.68,
   left: 165.6,
   width: 78.48,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.92,
   left: 302.88,
   width: 91.20,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.92,
   left: 442.8,
   width: 124.56,
   height: 11.149
}
,
{
   page: 0,
   name: "Agent Name_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 289.12,
   left: 146.16,
   width: 172.80,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Name_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 289.12,
   left: 376.32,
   width: 181.20,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 307.36,
   left: 155.28,
   width: 426.96,
   height: 11.149
}
,
{
   page: 0,
   name: "City_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.6,
   left: 113.28,
   width: 205.68,
   height: 11.149
}
,
{
   page: 0,
   name: "ZipPC_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.12,
   left: 432.0,
   width: 36.96,
   height: 11.149
}
,
{
   page: 0,
   name: "Country_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 323.88,
   left: 509.04,
   width: 74.793,
   height: 11.804
}
,
{
   page: 0,
   name: "Email Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 343.84,
   left: 153.84,
   width: 428.40,
   height: 11.149
}
,
{
   page: 0,
   name: "Agent Cell Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 361.08,
   left: 165.36,
   width: 78.72,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 361.32,
   left: 303.36,
   width: 91.20,
   height: 11.149
}
,
{
   page: 0,
   name: "Office Fax_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.84,
   left: 443.28,
   width: 140.924,
   height: 12.458
}
,
{
   page: 0,
   name: "Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 423.04,
   left: 131.28,
   width: 228.48,
   height: 11.149
}
,
{
   page: 0,
   name: "Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 422.56,
   left: 407.76,
   width: 160.56,
   height: 11.149
}
,
{
   page: 0,
   name: "Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 441.28,
   left: 130.08,
   width: 452.88,
   height: 11.149
}
,
{
   page: 0,
   name: "City_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.76,
   left: 113.52,
   width: 205.68,
   height: 11.149
}
,
{
   page: 0,
   name: "ZipPC_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.04,
   left: 432.96,
   width: 37.20,
   height: 11.149
}
,
{
   page: 0,
   name: "Country_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 458.8,
   left: 510.0,
   width: 73.724,
   height: 11.149
}
,
{
   page: 0,
   name: "Email Address_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 478.0,
   left: 154.32,
   width: 173.52,
   height: 11.149
}
,
{
   page: 0,
   name: "StateProv", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 476.8,
   left: 333.36,
   width: 250.32,
   height: 11.149
}
,
{
   page: 0,
   name: "Ce II Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.0,
   left: 140.64,
   width: 106.146,
   height: 10.495
}
,
{
   page: 0,
   name: "Home Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.0,
   left: 303.6,
   width: 91.2,
   height: 11.149
}
,
{
   page: 0,
   name: "Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.56,
   left: 432.0,
   width: 151.702,
   height: 11.149
}
,
{
   page: 0,
   name: "Additional Client Information 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 514.0,
   left: 208.8,
   width: 375.165,
   height: 11.804
}
,
{
   page: 0,
   name: "Client Address State", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.487,
   left: 370.714,
   width: 30.676,
   height: 11.149
}
,
{
   page: 0,
   name: "undefined_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 531.28,
   left: 95.8251,
   width: 488.0949,
   height: 12.458
}
,
{
   page: 0,
   name: "Percent Compensate Referring Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 610.887,
   left: 327.36,
   width: 24.00,
   height: 13.113
}
,
{
   page: 0,
   name: "other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 628.92,
   left: 119.52,
   width: 276.24,
   height: 13.113
}
,
{
   page: 0,
   name: "Date Referral Agreement Begins", 
   fontSize: 9,
   type: "date",
   top: 663.058,
   left: 338.967,
   width: 57.273,
   height: 14.422
}
,
{
   page: 0,
   name: "Date Referral Agreement Expires", 
   fontSize: 9,
   type: "date",
   top: 665.956,
   left: 479.52,
   width: 66.851,
   height: 11.804
}
,
{
   page: 0,
   name: "Signature Referring Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 701.3018,
   left: 94.1668,
   width: 168.8732,
   height: 12.4582
}
,
{
   page: 0,
   name: "Date Signature Referring Broker", 
   fontSize: 9,
   type: "date",
   top: 699.7527,
   left: 267.753,
   width: 50.508,
   height: 13.4908
}
,
{
   page: 0,
   name: "Signature Referring Empl Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 700.4072,
   left: 358.08,
   width: 162.066,
   height: 13.1128
}
,
{
   page: 0,
   name: "Date Signature Referring Empl Broker", 
   fontSize: 9,
   type: "date",
   top: 698.6872,
   left: 531.382,
   width: 50.508,
   height: 13.4909
}
,
{
   page: 0,
   name: "Signature Receiving Empl Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 746.2948,
   left: 361.789,
   width: 159.011,
   height: 12.4582
}
,
{
   page: 0,
   name: "Signature Receiving Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 746.8033,
   left: 96.2186,
   width: 163.7454,
   height: 12.8363
}
,
{
   page: 0,
   name: "Date Signature Receiving Broker", 
   fontSize: 9,
   type: "date",
   top: 745.8033,
   left: 267.753,
   width: 50.508,
   height: 13.4909
}
,
{
   page: 0,
   name: "Date Signature Receiving Empl Broker", 
   fontSize: 9,
   type: "date",
   top: 745.8397,
   left: 531.382,
   width: 50.508,
   height: 13.4908
}
,
{
   page: 0,
   name: "Text1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.311,
   left: 367.856,
   width: 32.836,
   height: 12.836
}
] }
